import { ImpulseFormShape, ImpulseFormUnit } from "~/tools/impulse-form";
import { isStringDirty } from "~/tools/is-string-dirty";
import type { Template } from "~/tools/template";

import {
	type DashboardMetricPromQLVariable,
	dashboardMetricPromQLVariableSchema,
} from "../../../../common/dashboard-spec";
import type { FormProcessor } from "../../_form-processor";
import { LabelNameFormProcessor, type LabelNameFormState } from "../_label-name";

export type FormState = ImpulseFormShape<{
	expression: ImpulseFormUnit<string, ReadonlyArray<string>, Template<["${", "}"], null>>;
	labelName: LabelNameFormState;
}>;

export const Processor: FormProcessor<FormState, undefined | DashboardMetricPromQLVariable> = {
	fromSpec: (spec) =>
		ImpulseFormShape({
			expression: ImpulseFormUnit(spec?.expr.source ?? "", {
				isInputDirty: isStringDirty,
				schema: dashboardMetricPromQLVariableSchema.shape.expr,
			}),
			labelName: LabelNameFormProcessor.fromSpec(spec?.labelName),
		}),

	toSpec: ({ expression, labelName }) => ({ expr: expression, labelName }),
};
